import React from "react"
import { CSSTransition } from "react-transition-group"
import Modal from "../Modal"

export default function ModalErrorServer({
  isOpen,
  phrases,
  setIsErrorModalOpen,
  onUpdate,
}) {
  return (
    <CSSTransition in={isOpen} appear unmountOnExit classNames="fade" timeout={300}>
      <Modal
        title={phrases.title}
        modalView="xs"
        cssModifyer="-mobile-bottom-sheet"
        onRequestClose={() => setIsErrorModalOpen(false)}
      >
        <div className="form-content">
          <p className="body-r-14">
            <span>{phrases.detail}</span>
          </p>
          <button
            type="button"
            className="wb-btn btn-green"
            onClick={() => {
              if (window.nextCartRequest) {
                window.globalCart?.setValue((prev) => ({
                  ...prev,
                  isLoading: true,
                }))
                $.ajax(window.nextCartRequest)
              }
              if (onUpdate) {
                onUpdate()
              }
            }}
          >
            <CSSTransition in={true} appear unmountOnExit classNames="fade" timeout={300}>
              <span>{phrases.button}</span>
            </CSSTransition>
          </button>
        </div>
      </Modal>
    </CSSTransition>
  )
}
